import { observeDisplayHeadings } from './display-headings';

const initPresentations = () => {
    document.querySelectorAll<HTMLElement>('.stgb-presentation:not(.stgb-presentation--editor)').forEach(observeDisplayHeadings);
    const root = document.documentElement;
    const sections = Array.from(document.querySelectorAll<HTMLElement>('.stgb-presentation.has-entrance-animation:not(.stgb-presentation--editor)'));
    const reveal = (section: HTMLElement) => section.classList.add('is-entrance-visible');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motion.matches || !('IntersectionObserver' in window)) {
        sections.forEach(reveal);
        return;
    }
    // Initial viewport content is painted by HTML/CSS, without a reveal dependency.
    const belowFold = sections.filter((section) => {
        if (section.getBoundingClientRect().top >= window.innerHeight) return true;
        section.classList.add('is-initially-visible');
        reveal(section);
        return false;
    });
    root.classList.add('stgb-presentation-ready');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal(entry.target as HTMLElement);
            observer.unobserve(entry.target);
        });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    belowFold.forEach((section) => observer.observe(section));
    const reduceMotion = () => {
        if (!motion.matches) return;
        observer.disconnect();
        root.classList.remove('stgb-presentation-ready');
        sections.forEach(reveal);
        motion.removeEventListener('change', reduceMotion);
    };
    motion.addEventListener('change', reduceMotion);
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPresentations, { once: true });
else initPresentations();
export {};
